import { Toast } from "primereact/toast";
import { createContext, RefObject, useContext } from "react";

interface AppToast {
  ref: RefObject<Toast> | undefined;
}

export const appToastContext = createContext<AppToast>({
  ref: undefined,
});

export const useAppToast = () => {
  return useContext(appToastContext);
};
